import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M6.5 2.75a.75.75 0 0 0-1.5 0v18.5a.75.75 0 0 0 1.5 0V2.75Zm9.045 1.938a1.391 1.391 0 0 0-1.521.306l-6.027 6.018a1.398 1.398 0 0 0 0 1.962L14.024 19c.402.411.985.526 1.512.306.526-.22.86-.717.87-1.282V5.97c0-.564-.344-1.062-.86-1.282Z" }, null, -1), a = [
  n
];
function r(s, l) {
  return e(), t("svg", c, [...a]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
